/*
 * 右侧 测试项目板块
 * */

'use strict';
var React = require('react');

var TestProjects = React.createClass({
  propTypes: {
    openApp: React.PropTypes.func.isRequired
  },
  render: function () {
    var projects = [
      'data/丫美券demo.mp'
    ];

    return (
      <div className='projects-list'>
        <h4>测试项目</h4>
        <ul>
          {projects.map(function (project) {
            return (
              <li key={project} onClick={this.openApp.bind(this, project)}>{project.replace('data/', '')}</li>
            );
          }, this)}
        </ul>
      </div>
    )
  },
  openApp: function (app) {
    this.props.openApp(app);
  }
});

module.exports = TestProjects;



// WEBPACK FOOTER //
// ./src/views/Dev/TestProjects.jsx